import _ from 'lodash';
import axios from 'axios';
import { getHKS } from 'utils/HKS';
import { getBrowser } from 'utils/Platform';
import { getRegion } from 'utils/Region';
import { getUserId } from 'utils/User';
import configureRequestInterceptor from './interceptors/requestInterceptor';
import configureResponseInterceptor from './interceptors/responseInterceptor';

export const buildParams = (withoutUserId = false) => {
  const apiCommonParams = {
    device_so: getBrowser(),
    HKS: getHKS(),
    region: getRegion(),
  };

  const userId = getUserId();

  if (userId !== '' && !withoutUserId) apiCommonParams.user_id = userId;

  return apiCommonParams;
};

const instance = axios.create({
  baseURL: process.env.URL_DOMINIO_MICROFWK,
  headers: {
    'content-type': 'application/x-www-form-urlencoded',
  },
  params: buildParams(),
});

configureRequestInterceptor(instance);
configureResponseInterceptor(instance);
export const apiCall = instance;

export const updateSwaggerManager = async (
  axiosInstance,
  newProperties = {},
) => {
  const props = { params: { ...newProperties } };
  await _.merge(axiosInstance.defaults, props);
  return axiosInstance;
};
